import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'editable-image-wrapper',
  standalone: false,
  template: `
    <div appEditableImage [innerHTML]="safeHtml"></div>`,
})
export class EditableImageWrapperComponent {
   safeHtml: SafeHtml = '';

  @Input() set htmlContent(val: string) {
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(val);
  }

  constructor(private sanitizer: DomSanitizer) {
  }
}
